import { render, staticRenderFns } from "./IncludedDetails.vue?vue&type=template&id=0530a102&scoped=true&"
import script from "./IncludedDetails.vue?vue&type=script&lang=js&"
export * from "./IncludedDetails.vue?vue&type=script&lang=js&"
import style0 from "./IncludedDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./IncludedDetails.vue?vue&type=style&index=1&id=0530a102&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0530a102",
  null
  
)

export default component.exports